import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import FormOfCareSelect from './FormOfCareSelect';

const FormOfCareSelectField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<FormOfCareSelect />
	</BaseField>
);

export default FormOfCareSelectField;
